import "./IconUser.scss";
import { ReactComponent as UserIcon } from "./svg/iconUser.svg";
import { ReactComponent as UserIconFilled } from "./svg/iconUserFilled.svg";

export type IconColor = "orange" | "green" | "gray" | "white" | "blue";
export type IconStyle = "outline" | "filled";
interface Props {
  color?: IconColor;
  iconStyle?: IconStyle;
}

export const IconUser = ({ color = "gray", iconStyle = "outline" }: Props) => {
  return <span className={`icon-user--${color}`}>{iconStyle === "outline" ? <UserIcon /> : <UserIconFilled />}</span>;
};
